
export enum DynamicPriceRateTypeCd {
	FLAT_RATE = 'FlatRate',
	PCT_RATE_BY_LINEHAUL = 'PctRateByLinehaul',
	PCT_RATE_BY_TOTAL = 'PctRateByTotal'}

